import React from 'react'

import { CardComponent } from 'components/commons/container/Card.component'
import { ImageFit } from 'components/commons/images/ImageFit.component'
import { Avatar } from '@/components/commons/images/Avatar.component'
import Image from 'next/image'
import { ButtonComponent } from 'components/commons/buttons/ButtonComponent'

// context + services + utils
import { ThemeContext } from 'context/theme/ThemeContext'
import { IMAGE_PATHS_V2 } from 'shared/consts/imagesPaths'
import { IGroupCardInfo } from 'interfaces'
// styles
import {
  groupCardBanner,
  groupCardContentContainer,
  avatarGroupContainer,
  groupCardTitle,
  connectionsGroupContainer,
} from 'styles/v2/pages/profile'

const connectionsStyles = 'cl-text-tertiary fs-14 fw-sm m-none'

export const GroupCard: React.FC<IGroupCardInfo> = ({
  cover,
  avatar,
  name,
  connections,
}) => {
  const { theme } = React.useContext(ThemeContext)
  return (
    <CardComponent>
      <div className={groupCardBanner}>
        <ImageFit
          key={'cover-group-' + name}
          src={cover}
          alt={'cover group ' + name}
        />
      </div>
      <div className={groupCardContentContainer}>
        <div className={avatarGroupContainer}>
          <Avatar
            key={'avatar-group-' + name}
            image={avatar}
            username={'Avatar group ' + name}
            size={80}
          />
        </div>
        <div>
          <span className={groupCardTitle}>{name}</span>
          <div className={connectionsGroupContainer}>
            <Image
              key={theme}
              src={IMAGE_PATHS_V2.icons.commons + theme + '/profiles_icon.svg'}
              alt="profiles icons"
              width={16}
              height={16}
            />
            <p className={connectionsStyles}>{connections} Members</p>
          </div>

          <ButtonComponent variation="secondary" fullWidth={true} label='Joined' />
        </div>
      </div>
    </CardComponent>
  )
}
